export const IMMUNITY_QUESTIONS = {
  safety: {
    id: 'safety',
    number: 1,
    text: 'First, let\'s confirm, do you currently have any of the following conditions?',
    hint: 'For your health and safety, we need to know these first',
    type: 'checkbox',
    options: [
      { value: 'pregnant', label: '🤰 Pregnant or breastfeeding' },
      { value: 'autoimmune', label: '🩺 Have autoimmune diseases (e.g., lupus, rheumatoid arthritis)' },
      { value: 'immunosuppressant', label: '💊 Taking immunosuppressants after organ transplant' },
      { value: 'fever', label: '🤒 Currently have a cold or fever' },
      { value: 'none', label: '✓ None of the above, continue', exclusive: true }
    ]
  },
  
  demographics: {
    id: 'demographics',
    number: 2,
    text: 'Tell us some basic information',
    type: 'multi-part',
    parts: [
      {
        id: 'age',
        label: 'Age Group',
        type: 'radio',
        options: [
          { value: '18-35', label: '18-35 years' },
          { value: '36-50', label: '36-50 years' },
          { value: '51-65', label: '51-65 years' },
          { value: 'other', label: 'Other age group' }
        ]
      },
      {
        id: 'weight',
        label: 'Weight',
        type: 'radio',
        options: [
          { value: '<50', label: '< 110 lbs (< 50 kg)' },
          { value: '50-70', label: '110-154 lbs (50-70 kg)' },
          { value: '70-90', label: '155-200 lbs (70-90 kg)' },
          { value: '>90', label: '> 200 lbs (> 90 kg)' }
        ]
      }
    ]
  },

  mainReason: {
    id: 'mainReason',
    number: 3,
    text: 'Main reason for wanting to boost immunity?',
    type: 'radio',
    options: [
      { value: 'frequent_cold', label: '🤧 Frequent colds, several times a year' },
      { value: 'fatigue', label: '😴 Always feel tired, low energy' },
      { value: 'seasonal', label: '🦠 Easily get sick during season changes' },
      { value: 'prevention', label: '💪 Want to preventively strengthen constitution' }
    ]
  },

  // 分支A：经常感冒
  coldFrequency: {
    id: 'coldFrequency',
    number: 4,
    text: 'How often do you catch a cold?',
    type: 'radio',
    condition: (answers) => answers.mainReason === 'frequent_cold',
    options: [
      { value: '1-2', label: '1-2 times a year (actually okay)' },
      { value: '3-4', label: '3-4 times a year' },
      { value: '5+', label: '5+ times a year (very frequent)' }
    ]
  },

  coldSymptoms: {
    id: 'coldSymptoms',
    number: 5,
    text: 'What are the main symptoms when you have a cold?',
    hint: 'Select all that apply',
    type: 'checkbox',
    condition: (answers) => answers.mainReason === 'frequent_cold',
    options: [
      { value: 'sweating', label: '😓 Easily sweat, sweat with slight movement' },
      { value: 'cold_limbs', label: '🧊 Fear of cold, cold hands and feet' },
      { value: 'runny_nose', label: '🤧 Runny nose, sneezing' },
      { value: 'sore_throat', label: '🔥 Sore throat, fever' }
    ]
  },

  recoveryTime: {
    id: 'recoveryTime',
    number: 6,
    text: 'How long does it take to recover from a cold?',
    type: 'radio',
    condition: (answers) => answers.mainReason === 'frequent_cold',
    options: [
      { value: '3-5days', label: 'Recover in 3-5 days' },
      { value: '1week', label: 'About a week' },
      { value: '>10days', label: 'Takes a long time, over 10 days' }
    ]
  },

  // 分支B：总感觉疲劳
  fatigueType: {
    id: 'fatigueType',
    number: 4,
    text: 'What does your fatigue feel like?',
    hint: 'Select all that apply',
    type: 'checkbox',
    condition: (answers) => answers.mainReason === 'fatigue',
    options: [
      { value: 'physical', label: '💪 Physical weakness, lazy to move' },
      { value: 'mental', label: '🧠 Mental fatigue, brain is tired' },
      { value: 'chronic', label: '💤 Still tired even after sleeping a lot' }
    ]
  },

  fatigueDuration: {
    id: 'fatigueDuration',
    number: 5,
    text: 'How long has this fatigue lasted?',
    type: 'radio',
    condition: (answers) => answers.mainReason === 'fatigue',
    options: [
      { value: '1-2months', label: 'Last 1-2 months' },
      { value: '3-6months', label: '3-6 months' },
      { value: '>6months', label: 'Over half a year' }
    ]
  },

  sleepQuality: {
    id: 'sleepQuality',
    number: 6,
    text: 'How is your sleep?',
    type: 'radio',
    condition: (answers) => answers.mainReason === 'fatigue',
    options: [
      { value: 'poor', label: '😴 Poor sleep, frequent insomnia' },
      { value: 'normal', label: '😊 Normal sleep' },
      { value: 'excessive', label: '💤 Sleep a lot but still tired' }
    ]
  },

  // 分支C：换季容易生病
  seasonalTime: {
    id: 'seasonalTime',
    number: 4,
    text: 'Which season do you easily get sick?',
    hint: 'Select all that apply',
    type: 'checkbox',
    condition: (answers) => answers.mainReason === 'seasonal',
    options: [
      { value: 'spring', label: '🌸 Spring (allergies, colds)' },
      { value: 'autumn_winter', label: '❄️ Autumn/Winter (cold weather makes it easy to catch a cold)' },
      { value: 'summer', label: '☀️ Summer (AC sickness, stomach discomfort)' }
    ]
  },

  seasonalSymptoms: {
    id: 'seasonalSymptoms',
    number: 5,
    text: 'Main discomfort during season changes?',
    hint: 'Select all that apply',
    type: 'checkbox',
    condition: (answers) => answers.mainReason === 'seasonal',
    options: [
      { value: 'sneeze', label: '🤧 Sneezing, runny nose' },
      { value: 'cold_fever', label: '🤒 Easy to catch cold/fever' },
      { value: 'fatigue', label: '😴 Very tired, no energy' },
      { value: 'digestive', label: '🤢 Stomach discomfort' }
    ]
  },

  // 分支D：预防性增强
  preventionGoal: {
    id: 'preventionGoal',
    number: 4,
    text: 'What do you mainly want to prevent?',
    hint: 'Select all that apply',
    type: 'checkbox',
    condition: (answers) => answers.mainReason === 'prevention',
    options: [
      { value: 'prevent_cold', label: '🦠 Prevent colds' },
      { value: 'boost_energy', label: '💪 Boost physical strength and energy' },
      { value: 'stress', label: '😌 Improve lowered immunity due to stress' },
      { value: 'exercise', label: '🏃 Support for exercise/workout' }
    ]
  },

  // 通用问题
  constitution: {
    id: 'constitution',
    number: 7,
    text: 'Your usual constitution characteristics?',
    hint: 'Select all that apply',
    type: 'checkbox',
    options: [
      { value: 'night_sweat', label: '😓 Easily have night sweats (sweat without exercise)' },
      { value: 'dry_mouth', label: '💧 Easily dry mouth, always want to drink water' },
      { value: 'cold_limbs', label: '🧊 Cold hands and feet' },
      { value: 'heat_intolerance', label: '🌡️ Fear of heat, easily get inflamed' },
      { value: 'none', label: 'None of the above', exclusive: true }
    ]
  },

  stress: {
    id: 'stress',
    number: 8,
    text: 'Stress and life status?',
    type: 'radio',
    options: [
      { value: 'high', label: '😫 Work/study stress is high' },
      { value: 'moderate', label: '😊 Moderate stress' },
      { value: 'low', label: '😌 Relatively relaxed' }
    ]
  },

  otherSymptoms: {
    id: 'otherSymptoms',
    number: 9,
    text: 'Do you also have these conditions?',
    hint: 'Select all that apply',
    type: 'checkbox',
    options: [
      { value: 'loose_stool', label: '💩 Loose stools (diarrhea)' },
      { value: 'poor_appetite', label: '🍽️ Poor appetite' },
      { value: 'shortness_breath', label: '😮‍💨 Shortness of breath, tired climbing stairs' },
      { value: 'none', label: 'None of the above', exclusive: true }
    ]
  }
};